export const SURVEY_QUESTIONS = [
  '¿Consideras que el tiempo de atención del servicio fue oportuno?',
  '¿Consideras que la calidad del servicio brindado fue el adecuado?',
  '¿El trato proporcionado por el asesor telefónico fue de calidad?',
  '¿El trato proporcionado por el vendedor fue de calidad?',
  '¿Ha sido satisfactoria tu experiencia con los Productos/Servicios ofrecidos por Gas del Lago con anterioridad?',
  '¿En que podemos mejorar?',
];
